import React, { FC, useEffect, useState } from 'react';
import axios, { AxiosRequestHeaders } from 'axios';
import { Formik, Field, Form } from "formik";
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';

const UserUpdate: FC = () => {
  const { id } = useParams();
  const userDataIntialState = { userid: id, name: "", mobile: "", password: "" };
  const [updateData, SetUpdateData] = useState(userDataIntialState);
  const [modalShow, setModalShow] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [status, setStatus] = useState(false);  
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  
  const [modalMessage, setModalMessage] = useState('');
  const [pendingValues, setPendingValues] = useState<any>(null); 
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const headers: AxiosRequestHeaders = {
      "x-access-token": localStorage.getItem("jwttoken") || "",
    };

  const callUserUpdateApi = async (values: any) => {
      setModalMessage("Are you sure you want to update this candidate?");
      setPendingAction(() => async () => {
        try {
          const url = process.env.REACT_APP_API_URL + 'users/updateusers';
          const response = await axios.put(url, values, {headers});
          if (response.status === 200) {
            setSuccessMessage("User Updated successfully.");
            setStatus(true);
            setShowSuccessModal(true);
            setTimeout(() => navigate(-1), 1000);
          }
         
        } catch (error: any) {
          if (error.response) {
            if (error.response.status === 400) {
              setFailureMessage("Both Email and Mobile already exist");
            } else if (error.response.status === 401) {
              setFailureMessage("Email already exists");
            } else if (error.response.status === 402) {
              setFailureMessage("Mobile already exists");
            } else {
              setFailureMessage("Network Error. Failed to update user.");
            }
          } else {
            setFailureMessage("Network Error. Please try again later.");
          }
          setShowFailureModal(true);
       }
      });       
      setModalShow(true);
    }

  const getUserByIdApi = async (id: any) => {
    const url = process.env.REACT_APP_API_URL + 'users/searchuser/' + id;
    const response = await axios.get(url,{headers});
    return response.data;
  };

  useEffect(() => {
    (async () => {
      const data = await getUserByIdApi(id);
      SetUpdateData(data[0]);
    })();
  }, [id]);

  const handleModalOk = () => {
    setModalShow(false);
    
    if (pendingAction) {
      pendingAction();
    }
    if (status) {
      const token = localStorage.getItem('jwttoken');
      if (token) {
        navigate('/userslist')
      }
      return {
        error: false
      }
    }
    }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Update User</h4>
            </Card.Header>
            <Card.Body>
       <Formik
                      enableReinitialize={true}
                      initialValues={updateData}
                      onSubmit={async (values) => {
                        if (JSON.stringify(values) === JSON.stringify(updateData)) {
                          setSuccessMessage("No changes were made");
                          setShowSuccessModal(true);
                          return; 
                        }
                        await callUserUpdateApi(values);
                      }}

      >
        {() => (
                  <Form>
                    <Field hidden type="number" name="userid" />

                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="name" className="form-label">
                          Name:
                        </label>
                        <Field
                          name="name"
                          type="text"
                          className="form-control"
                          placeholder="Enter Name" required
                        />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="mobile" className="form-label">
                          Mobile:
                        </label>
                        <Field
                          name="mobile"
                          type="text"
                          className="form-control"
                          placeholder="Enter Mobile Number" required
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="email" className="form-label">
                          Email:
                        </label>
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="Enter Email" required
                        />
                      </Col>
                      <Col md={6}>
                        <label htmlFor="password" className="form-label">
                          Password:
                        </label>
                        <div className="position-relative">
                          <Field
                            name="password"
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder="Enter Password" 
                            required
                          />
                          <i
                            className={`position-absolute top-50 translate-middle-y end-0 me-3 fas ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          ></i>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success">
                          Update User
                        </Button>
                        <Button variant="danger" className="mx-2" onClick={() => navigate(-1)}>
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
             <ConfirmationModal
                             show={modalShow}
                             modalMessage={modalMessage}
                             onHide={() => setModalShow(false)}
                             confirmation={handleModalOk}
                             operationType="Confirm"
                           />
                   <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="Ok" timeoutDuration={3000} />
             <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage}  operationType="Ok" timeoutDuration={5000}/>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      </Container>
  );
};

export default UserUpdate;
